export const PublisherType = Object.freeze({
  CANDIDATE: 'candidate',
  HR: 'hr',
});

export const ApiUrls = Object.freeze({
  V1: '/api/v1',
});

export const UserType = Object.freeze({
  CANDIDATE: 'candidate',
  ADMIN: 'admin',
});

export const RoomErrors = Object.freeze({
  UNAUTHORIZED: 'unauthorized',
});

export const localeType = Object.freeze({
  EN: 'en',
  RU: 'ru',
  UK: 'ru',
  BE: 'ru',
  KK: 'ru',
  DEFAULT: 'en',
});
